import { Injectable } from '@angular/core';
import { isDefined } from '@fi-shared/utils/is-defined';
import { ExtendedSearchTypesService } from '../../extended-search/extended-search-types.service';
import {
    IOperationOverlayLargeDialogData,
    OperationOverlayLargeNg4Service,
} from '../operation-overlay-large/operation-overlay-large.service';
import { promiseUnwrap } from '@fi-shared/fi-shared-services/extensions.service';
import { ExtendedSearchListComponent } from '../../extended-search/extended-search-list/extended-search-list.component';
import { ObjectTypes } from '@fi-shared/types';
@Injectable()
export class ExtendedSearchService {
    constructor(
        private extendedSearchTypesService: ExtendedSearchTypesService,
        private operationOverlayLargeService: OperationOverlayLargeNg4Service,
    ) {}

    openExtendedSearch(objectType, params?: IOperationOverlayLargeDialogData): Promise<any> {
        const settings = this.extendedSearchTypesService.getExtendedSearchSettings(objectType);
        if (!isDefined(settings)) {
            throw 'FI: Unknown extended search type: "' + objectType + '"';
        }
        const promise = new Promise<any>((resolve, reject) => {
            promiseUnwrap(settings.listSettings.resolve).then((resolvedData) => {
                settings.listSettings.resolve = resolvedData;
                if (objectType === ObjectTypes.MediaBank) {
                    settings.listSettings.resolve.allowSelection = true;
                }
                this.operationOverlayLargeService
                    .openOperationOverlayLargeDialog(ExtendedSearchListComponent, settings, params)
                    .afterClosed()
                    .subscribe((result) => resolve(result), reject);
            });
        });

        return promise;
    }
}
